import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Tracker from './pages/Tracker';
import DashboardLayout from "./pages/DashboardLayout";
import Home from './pages/Home';
import ColdEmailing from './pages/Coldemails';
import CoffeeChats from './pages/CoffeeChats';
import Networking from './pages/Networking';
import Onboarding from './pages/Onboarding';
import Cancel from "./pages/Cancel";
import Drafts from './pages/Applications';
import DreamCompanies from './pages/DreamCompanies';
import NewRoles from './pages/NewRoles';
import InterviewPrep from './pages/InterviewPrep';
import SettingsLayout from './pages/settings/SettingsLayout';
import ProfileSettings from './pages/settings/ProfileSettings';
import JobSearchSettings from './pages/settings/JobSearchSettings';
import PlanSettings from './pages/settings/PlanSettings';
import ArchivesSettings from './pages/settings/ArchivesSettings';
import ArchiveView from './pages/ArchiveView';
import PageTitle from './components/PageTitle';
// import Success from './pages/Success';
import { MotionConfig } from 'framer-motion';
import { TooltipProvider } from './components/ui/tooltip';

import './styles/tailwind.css';

const App: React.FC = () => {
  return (
    <MotionConfig reducedMotion="user">
    <TooltipProvider delayDuration={200}>
    <Router>
      <PageTitle />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<Onboarding />} />
        {/* Settings is its own full page with its own sidebar */}
        <Route path="/settings" element={<SettingsLayout />}>
          <Route index element={<Navigate to="profile" replace />} />
          <Route path="profile" element={<ProfileSettings />} />
          <Route path="job-search" element={<JobSearchSettings />} />
          <Route path="plan" element={<PlanSettings />} />
          <Route path="archives" element={<ArchivesSettings />} />
        </Route>
        <Route element={<DashboardLayout />}>
        <Route path="dashboard/home" element={<Home />} />
        <Route path="dashboard/tracker" element={<Tracker />} />
        <Route path="dashboard/coldemails" element={<ColdEmailing />} />
        {/* Career Building's goals live in Interview Prep now */}
        <Route path="dashboard/career" element={<Navigate to="/dashboard/prep" replace />} />
        <Route path="dashboard/coffeechats" element={< CoffeeChats/>} />
        <Route path="dashboard/networking" element={<Networking />} />
        <Route path="dashboard/applications" element={<Drafts />} />
        <Route path="dashboard/dreamcompanies" element={<DreamCompanies />} />
        <Route path="dashboard/roles" element={<NewRoles />} />
        <Route path="dashboard/prep" element={<InterviewPrep />} />
        {/* <Route path="/success" element={<Success />} /> */}
        <Route path="/cancel" element={<Cancel />} />
        {/* An archived cycle is a board, so it keeps the app shell and top bar */}
        <Route path="/settings/archives/:id" element={<ArchiveView />} />
        
        </Route>
      </Routes>
    </Router>
    </TooltipProvider>
    </MotionConfig>
  );
};

export default App;
